import { render, staticRenderFns } from "./plan_sel.vue?vue&type=template&id=b8bdc5d4&scoped=true"
import script from "./plan_sel.vue?vue&type=script&lang=js"
export * from "./plan_sel.vue?vue&type=script&lang=js"
import style0 from "./plan_sel.vue?vue&type=style&index=0&id=b8bdc5d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bdc5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8bdc5d4')) {
      api.createRecord('b8bdc5d4', component.options)
    } else {
      api.reload('b8bdc5d4', component.options)
    }
    module.hot.accept("./plan_sel.vue?vue&type=template&id=b8bdc5d4&scoped=true", function () {
      api.rerender('b8bdc5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/plan_sel.vue"
export default component.exports